import { render } from "./GastronomyCard.vue?vue&type=template&id=1f46835d&scoped=true"
import script from "./GastronomyCard.vue?vue&type=script&lang=js"
export * from "./GastronomyCard.vue?vue&type=script&lang=js"

import "./GastronomyCard.vue?vue&type=style&index=0&id=1f46835d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f46835d"]])

export default __exports__